import PlayButton from './PlayButton';

export { type PlayButtonProps } from './PlayButton';
export default PlayButton;
